export default __webpack_public_path__ + "full-screen-image-mask.svg";